
<template>

	<div class="panel-body">

		<div class="col-xs-12">
			<div class="form-group">
                <label>Term</label>
                <select 
                	@change="loadTermData()"
                	class="form-control"               	
                	v-model="selectedTerm">                		
                	<option v-for="term in terms" :value="term.id">
                		{{term.name}}
                	</option>
            	</select>
            </div>
           <div class="form-group" v-if="supervisors">
           		<label>Supervisor</label>
           		<select
           			@change="getFeedback"
           			class="form-control"
           			v-model="selectedSupervisor">
           			<option v-for="supervisor in supervisors" :value="supervisor.id">
           				{{supervisor.firstName}} {{supervisor.lastName}}
           			</option>
           		</select>
           </div>
           
           <div v-if="submissions">
           		<div class="week-jumper">
           			<span class="week-jumper-label">Week</span>
		   			<span v-for="week in 14" class="week-jumper-week" @click="jumpToWeek(week)">
		   				{{week}}
		   			</span>

           		</div>
           		<table class="table table-striped table-bordered">
           			<thead>
           				<tr>
           					<th>Week</th>
           					<th>Assignment</th>           					
           					<th>Student Name</th>
           					<th>Submission</th>           					
           					<th class="text-center">Feedback</th>
           				</tr>
           			</thead>
           			<tbody>
           				<tr v-for="submission in submissions" :class="'submission-' + submission.week">
           					<td>{{submission.week}}</td>
           					<td>{{submission.assignmentName}}</td>
           					<td>
           						<router-link :to="{ name: 'student', params: { studentId: submission.student.populiId }, query: {userId: submission.student.id, term: selectedTerm}}" target="_blank">
   									{{submission.student.firstName}} {{submission.student.lastName}}
   								</router-link>
           					</td>           					
           					<td>
           						<span v-if="submission.url">
   									<a v-for="(link, $index) in submission.url" :href="link" target="_blank">
   										<span v-if="$index > 0">/</span> File {{$index + 1}} 
   									</a>
				                    <i v-if="submission.comments" class="clippie fa fa-comment cursor-pointer" v-tooltip="submission.comments"></i>
   								</span>
   								<span class="feedback-meta">
   									{{submission.createdAt | shortDate}}
   								</span>
           					</td>
           					<td class="text-center">
           						<span v-if="submission.feedback">           									
   									<a class="feedback-link" :href="getTranscodedUrl(submission.feedback.body)" target="_blank">
   										<img class="play-button" src="../../assets/img/play-button-small-green.png" />
   										 <!-- <video width="100">
   											<source :src="submission.feedback.body" type="video/webm">
   										</video>  -->
   										 <!-- <span>Link</span>  -->
   									</a>
   									<span class="feedback-meta">
   										{{submission.feedback.createdAt | shortDate}}
									</span>
   									<span class="feedback-meta">
   										{{Math.round(submission.feedback.duration / 60)}} min
									</span>
									
   								</span>
   								<span v-else>
   									No feedback
   								</span>
   							</td>

           				</tr>
           			</tbody>
           		</table>
           </div>
		</div>

	</div>

</template>

<script>

import terms from './../../services/terms';
import assignments from './../../services/assignments';
import users from './../../services/users';

import _ from 'lodash';
import moment from 'moment';
import toastr from 'toastr';

export default {
    data() {
        return {
        	terms: null,
        	groups: null,
        	groupIds: null,
        	assignments: null,
        	submissions: null,
        	supervisors: null,
        	selectedTerm: null,
        	selectedSupervisor:null,
        }
    },
    components: {

    },
    created() {
  		const now = new Date();
        terms.get(this).then(async (response) => {
            this.terms = response.data.terms.filter(t => new Date(t.startDate) < now && t.type !== 'mentorship' && !t.name.toLowerCase().includes('challenge'))
            this.selectedTerm = this.terms[0].id;   
            this.loadTermData();
        });
    },
    mounted() {

    },
    methods: {
    	jumpToWeek(week) {
    		if (document.querySelector('tr.submission-' + week)) {
    			document.querySelector('tr.submission-' + week).scrollIntoView();
    		} else {
    			toastr.error('No submissions for that week');
    		}
    	},
    	async loadTermData() {
    		this.submissions = null; 
    		this.supervisors = null;
    		await this.getTermGroups();
            this.getSupervisors();
    	},
    	getTranscodedUrl(url) {
    		let transcodedUrl = url.replace('ttto-feedback.s3.amazonaws.com','ttto-feedback-transcoded.s3.us-west-2.amazonaws.com').replace('.webm', '.mp4');
    		return transcodedUrl;
    	},
    	feedbackLength(submissions) {
    		let feedback = submissions.filter(s => s.feedback);
			return feedback.length;	
    	},
    	getTermGroups() {
    		return users.getGroups(this, this.selectedTerm).then((response)=>{
    			this.groups = response.data.groups;
    			this.groupIds = this.groups.map(g => g.id);
    			return true;
    		})
    	},
    	getSupervisors() {
    		users.getAll(this, 'Supervisor',null).then((response)=>{
    			this.supervisors = response.data.filter((u)=>{
    				return _.intersection(u.group, this.groupIds).length > 0;
    			});    			
    		});
    	},
    	getFeedback() {
    		if (!this.selectedSupervisor) { return; }

    		this.$store.dispatch('toggle',{type:'loading', boolean: true});	
    		this.submissions = null;

    		const supervisor = this.supervisors.find(s => s.id === this.selectedSupervisor);    		
    		const termGroups = supervisor.group.filter(g => this.groupIds.includes(g));

    		assignments.getFeedback({supervisorId: this.selectedSupervisor, termId: this.selectedTerm, groups: termGroups}).then((response)=>{
    			let submissions = response.data.assignments.map((a) => {
    				// map submissions to include assignment name and week

    				return a.assignment_submissions.map((s)=>{
    					s.assignmentName = a.name;
    					s.week = a.week;
    					return s;
    				})
    			});

    			submissions = submissions.flat();

    			submissions = submissions.sort((a, b) => {
					// Sort by week, then within the week by assignment name					
					if (a.week > b.week) return 1;
					if (a.week < b.week) return -1;
					
					if (a.assignmentName > b.assignmentName) return 1;
					if (a.assignmentName < b.assignmentName) return -1;
				});
    			
    			this.submissions = submissions;
    			this.$store.dispatch('toggle',{type:'loading', boolean: false});	
    		}).catch((e)=>{    			
    			this.$store.dispatch('toggle',{type:'loading', boolean: false});	
    		});
    		
    	}
    	// getFeedback() {
	    
	    // 	

    	// 	assignments.getFeedback(this.selectedTerm, this.selectedWeek).then((response)=>{
    	// 		let assignmentData = response.data.assignments;
    	// 		console.log(assignmentData)
    	// 		for (const assignment of assignmentData) {
    	// 			assignment.assignment_submissions = assignment.assignment_submissions.sort((a,b)=>{
    	// 				const firstLetterA = a.feedback ? a.feedback.user.firstName.charAt(0).toLowerCase() : 'Z';
    	// 				const firstLetterB  = b.feedback ? b.feedback.user.firstName.charAt(0).toLowerCase() : 'Z';
    	// 				return firstLetterA.localeCompare(firstLetterB)   					
    	// 			})
    	// 		}
    	// 		this.assignments = assignmentData;
    	// 		this.$store.dispatch('toggle',{type:'loading', boolean: false});
    	// 	}).catch((e)=>{
    	// 		this.$store.dispatch('toggle',{type:'loading', boolean: false});
    	// 	})
    	// }
    },
    computed: {
		termStart() {
    		return this.terms.find(t => t.id === this.selectedTerm).startDate
    	}
    }
}
</script>

<style lang="scss" scoped>
.week-jumper {
	font-size: 16px;
	margin-bottom:1rem;
	.week-jumper-week {
		cursor: pointer;
		&:hover {
			color: #3cf;
		}
	}
}
.feedback-meta {
	display:block;
}
.no-feedback {
	margin-bottom:3rem;
}
.feedback-link {
	position:relative;
	img {
		width:24px;
		height:24px;
		margin-bottom:6px;
	}
	span {
		position:absolute;
		top:0;
		left:0;right:0;
		bottom:0;
		margin:auto;
		z-index:9;
	}
	video {
		position: relative;
		z-index:99
	}
}
h4 {
	margin-bottom:2rem;
}
table {
	table-layout: fixed;
}
</style>


// WEBPACK FOOTER //
// DirectorFeedback.vue?7f2162e9